import Gnav from "./_gnav.es6";
import Loading from "./_loading.es6";
import Mainvisual from "./_mainvisual.es6";
import MainvisualChange from "./_mainvisual_change.es6";
import Banner from "./_banner.es6";

export default class Main {
    constructor() {
        this.init();
    }

    init() {
        const gnav = new Gnav();
        const loading = new Loading();
        const mainvisual = new Mainvisual();
        const mainvisualchange = new MainvisualChange();
        const banner = new Banner();
    }
}
